import ConfirmDialog from '../lib/ConfirmDialog.js';
import el from '@finn-no/create-element';

export default {
    dependencies: ['$element', 'xhrservice', 'trackingservice'],
    callable(ele, xhrservice, trackingService) {
        const url = new URL(document.baseURI);
        const finnkode = url.searchParams.get('finnkode');
        const showUpsaleButton = ele.querySelector(
            '[data-toolbox-upsale-button]'
        );
        const container = ele.querySelector('[data-toolbox-upsale]');
        let baseUrl;
        let upsellProductsBoughtList = [];
        container.classList.add('hidden');

        const hideShowUpsaleButton = function() {
            showUpsaleButton.parentElement.classList.add('hidden');
        };

        const upsaleButtonTrackingTag = `${showUpsaleButton.getAttribute(
            'data-upsale-button-tracking-tag'
        )} - buyupsaleproducts - statistics`;

        showUpsaleButton.addEventListener('click', event => {
            // TODO this
            container.classList.remove('hidden');
            const options = {
                size: {
                    top: '100px',
                    bottom: '40px',
                    left: '40px',
                    right: '40px',
                    maxWidth: '824px',
                },
            };
            new ConfirmDialog(
                'Kjøp mer synlighet',
                container,
                null,
                'Avbryt',
                options
            ).show();
            event.stopPropagation();
            const eventName = `${upsaleButtonTrackingTag} - click`;

            trackingService.deprecatedTrackEvent(eventName);
        });

        function getUpsaleProducts() {
            const requestPromise = xhrservice.request({
                url: '/user/upsaleProducts.json',
                method: 'GET',
                data: { finnkode },
                type: 'json',
            });

            return requestPromise.then(handleSuccess);
        }

        function getPurchaseUrl(product) {
            return `${product.purchase.href.split('?')[0]}/multi`;
        }

        function checkIfProductIsAvailable(group) {
            return upsellProductsBoughtList.includes(group);
        }

        function createUpsaleEntry(product) {
            const alreadyBought =
                product.status != null && product.status.match(/ACTIVE/);
            const singularSelectionGroup = product.singularSelectionGroup
                ? product.singularSelectionGroup
                : '';
            const isMutuallyExclusive = checkIfProductIsAvailable(
                product.singularSelectionGroup
            );
            const isDisabled = alreadyBought || isMutuallyExclusive;
            const labelClass = isDisabled
                ? 'label.media.ptm.sardine'
                : 'label.media.ptm';

            return el(
                labelClass,
                null,
                el(
                    'div.imgExt.price.t3.plm',
                    null,
                    alreadyBought
                        ? 'Kjøpt'
                        : getPriceFromFormattedString(product.priceFormatted)
                ),
                el(
                    'div.img.mrm',
                    null,
                    el('input', {
                        type: 'checkbox',
                        name: 'specid',
                        value: product.id,
                        id: product.id,
                        checked: alreadyBought,
                        disabled: isDisabled,
                        'data-upsale-price': getPriceFromFormattedString(
                            product.priceFormatted
                        ),
                        'data-singular-selection-group': singularSelectionGroup,
                    })
                ),
                el(
                    'div.bd',
                    null,
                    el('span.mln.t3', null, product.name),
                    el('p.mln', null, product.description)
                ),
                el('hr.r-margin', { role: 'presentation' })
            );
        }

        function trackShowingUpsaleButton() {
            const eventName = `${upsaleButtonTrackingTag} - show`;
            trackingService.deprecatedTrackEvent(eventName);
        }

        function setUpsellProductsBoughtList(products) {
            products
                .filter(
                    product =>
                        product.status != null &&
                        product.status.match(/ACTIVE/) &&
                        product.singularSelectionGroup
                )
                .forEach(product => {
                    upsellProductsBoughtList.push(
                        product.singularSelectionGroup
                    );
                });
            if (upsellProductsBoughtList.length > 1) {
                upsellProductsBoughtList = upsellProductsBoughtList.filter(
                    (el, i, arr) => arr.indexOf(el) === i
                );
            }
        }

        function handleSuccess(products) {
            if (products && products.length) {
                baseUrl = getPurchaseUrl(products[0]); // this is the dumbest
                setUpsellProductsBoughtList(products);
                showUpsaleButtons(products);
                trackShowingUpsaleButton();
            } else {
                hideShowUpsaleButton();
            }
        }

        function getSelectedProducts() {
            return Array.from(
                container.querySelectorAll('input[data-upsale-price]')
            )
                .filter(e => !e.disabled && e.checked)
                .map(e => ({
                    pid: e.value,
                    price: parseInt(e.getAttribute('data-upsale-price')),
                }));
        }

        function buildUpsaleUrl(products) {
            const url = new URL(baseUrl, document.baseURI);
            url.searchParams.set('adId', finnkode);
            url.searchParams.set('callback', window.location.href);
            products.forEach(product =>
                url.searchParams.append('specId', product.pid)
            );
            return url.toString();
        }

        function handleMutuallyExclusiveProducts(evt) {
            const eleClicked = evt.target;
            if (!eleClicked) {
                return false;
            }
            let inputClicked = null;
            if (eleClicked.tagName === 'INPUT') {
                inputClicked = eleClicked;
            } else {
                const label = eleClicked.closest('label');
                if (label) {
                    inputClicked = label.querySelector('input');
                }
            }

            // check input if span clicked
            if (!inputClicked || inputClicked.disabled) {
                return false;
            }

            const groupValue = inputClicked.getAttribute(
                'data-singular-selection-group'
            );

            if (groupValue !== '') {
                const upsellProducts = container.querySelectorAll(
                    '[data-singular-selection-group]'
                );
                const selectionGroup = Array.from(upsellProducts).filter(
                    product =>
                        product.getAttribute(
                            'data-singular-selection-group'
                        ) === groupValue
                );
                if (inputClicked.checked) {
                    Array.from(selectionGroup)
                        .filter(product => !product.checked)
                        .forEach(input => {
                            input.disabled = 'disabled';
                            input.closest('label').classList.add('sardine');
                        });
                } else {
                    Array.from(selectionGroup).forEach(input => {
                        if (input.disabled) {
                            input.removeAttribute('disabled');
                            input.closest('label').classList.remove('sardine');
                        }
                    });
                }
            }
        }

        function handleUpsaleProductToggle(evt) {
            handleMutuallyExclusiveProducts(evt);
            const price = getSelectedProducts()
                .map(e => e.price)
                .reduce((a, b) => a + b, 0);
            container.querySelector('[data-upsale-total]').textContent = price;
        }

        function handleBuyProducts() {
            const products = getSelectedProducts();
            if (products.length) {
                window.location = buildUpsaleUrl(products);
            }
        }

        function showUpsaleButtons(products) {
            container.appendChild(
                el(
                    'div',
                    null,
                    el(
                        'div',
                        { onclick: handleUpsaleProductToggle },
                        products.map(createUpsaleEntry)
                    ),
                    el(
                        'div.media.ptm.licorice',
                        null,
                        el(
                            'div.imgExt.price.t2.plm',
                            { 'data-upsale-total': '' },
                            '0'
                        ),
                        el('div.bd', null, el('span.mln.t2', null, 'Totalpris'))
                    ),
                    el(
                        'div.r-margin',
                        { onclick: handleBuyProducts },
                        el(
                            'a.button.large.fullwidth.pvl.primary.mtl',
                            { 'data-upsale-buy': '' },
                            'Gå til betaling'
                        )
                    )
                )
            );
        }

        function getPriceFromFormattedString(formattedPrice) {
            return parseInt(formattedPrice.replace(/[^0-9]/g, ''), 10);
        }

        return getUpsaleProducts();
    },
};



// WEBPACK FOOTER //
// ./controllers/adOwnerToolboxUpsale.js